export const APP_NAME = "Patongen Elgongen";
